"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "groupTeams", {
    enumerable: true,
    get: function() {
        return groupTeams;
    }
});
const _groupby = require("./group-by");
const _getid = require("./get-id");
const groupTeams = (items = [], simulated = false)=>{
    if (simulated) {
        return (0, _groupby.groupBy)(items, "groupId");
    } else {
        const teams = items.length > 0 ? (0, _groupby.groupBy)(items, "groupId") : {
            [(0, _getid.getId)()]: []
        };
        return Object.assign({}, teams, {
            [(0, _getid.getId)()]: []
        });
    }
};
